import { render, staticRenderFns } from "./MainMobile.vue?vue&type=template&id=10d73ae6&"
import script from "./MainMobile.vue?vue&type=script&lang=js&"
export * from "./MainMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports